import { useState } from "react";
import {
  EMAIL_FORMAT_REGEX,
  EMAIL_MAX_LENGTH,
  EMPTY_CONTACT_ERRORS,
  NAME_MAX_LENGTH,
  PHONE_MAX_LENGTH,
} from "./ticketFormConfig";
import { getFieldInputError, getMissingContactFields } from "./ticketFormHelpers";

// State and handlers of the "עדכון איש קשר" dialog.
// onSaved runs once a valid contact person is saved, so the form can uncheck "contact person confirmed".
export const useContactChangeRequest = (onSaved) => {
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const [contactNameChangeRequest, setContactNameChangeRequest] = useState("");
  const [contactPhoneChangeRequest, setContactPhoneChangeRequest] = useState("");
  const [contactEmailChangeRequest, setContactEmailChangeRequest] = useState("");
  const [contactFieldErrors, setContactFieldErrors] = useState(EMPTY_CONTACT_ERRORS);
  const values = { contactNameChangeRequest, contactPhoneChangeRequest, contactEmailChangeRequest };

  // Keeps the typed value only when it's allowed, otherwise shows why under the field
  const handleContactInput = (errorKey, setValue, label, maxLength, allowed) => (event) => {
    const value = event.target.value;
    const error = getFieldInputError(value, label, maxLength, allowed);
    if (error) {
      setContactFieldErrors((prev) => ({ ...prev, [errorKey]: error }));
      return;
    }
    setValue(value);
    setContactFieldErrors((prev) => ({ ...prev, [errorKey]: "" }));
  };

  const handleContactDialogCancel = () => {
    setContactDialogOpen(false);
    setContactNameChangeRequest("");
    setContactPhoneChangeRequest("");
    setContactEmailChangeRequest("");
    setContactFieldErrors(EMPTY_CONTACT_ERRORS);
  };

  const handleContactDialogSave = () => {
    const missingRequiredErrors = getMissingContactFields(values);
    if (Object.keys(missingRequiredErrors).length > 0) {
      setContactFieldErrors((prev) => ({ ...prev, ...missingRequiredErrors }));
      return;
    }

    setContactDialogOpen(false);
    onSaved();
    setContactFieldErrors(EMPTY_CONTACT_ERRORS);
  };

  const contactEmailFormatInvalid = !!contactEmailChangeRequest && !EMAIL_FORMAT_REGEX.test(contactEmailChangeRequest);

  return {
    ...values, contactDialogOpen, setContactDialogOpen, contactFieldErrors, contactEmailFormatInvalid,
    handleContactDialogCancel, handleContactDialogSave,
    handleContactNameChangeInput: handleContactInput("contactName", setContactNameChangeRequest, "שם איש קשר", NAME_MAX_LENGTH, "letters"),
    handleContactPhoneChangeInput: handleContactInput("contactPhone", setContactPhoneChangeRequest, "טלפון", PHONE_MAX_LENGTH, "digits"),
    handleContactEmailChangeInput: handleContactInput("contactEmail", setContactEmailChangeRequest, "אימייל", EMAIL_MAX_LENGTH),
  };
};
